import React, { useContext, useEffect } from "react";
import { Box, Paper, useMediaQuery } from "@material-ui/core";
import { ProcessContext } from "../../../contexts/ProcessContext";
import { FLOW_MESSAGES } from "../components/flowMessages/components";
import ResponsiveLayout from "../components/ResponsiveLayout";
import { useTheme } from "@material-ui/styles";

export default function FlowMessagesWindowManager() {
  const {
    state: { flowMessage },
    dispatch,
  } = useContext(ProcessContext);
  const [state, setState] = React.useState({
    currentFlowMessage: undefined,
    forceDisplay: false,
    fading: false,
    hideAnimation: false,
  });
  const { breakpoints } = useTheme();
  const isScreenXs = useMediaQuery(breakpoints.down("xs"));

  const { forceDisplay, fading, hideAnimation, currentFlowMessage } = state;
  const HIDE_ANIMATION_START_TIME_FROM_END = 800;
  const FADE_DURATION = 500;
  const fadeStartTimeFromHidingStartTime =
    HIDE_ANIMATION_START_TIME_FROM_END - FADE_DURATION;
  const messageDuration = FLOW_MESSAGES[flowMessage?.id]?.messageDuration;
  const hidingMessageStartTime =
    messageDuration - HIDE_ANIMATION_START_TIME_FROM_END;

  useEffect(() => {
    if (
      flowMessage?.id &&
      flowMessage?.id !== currentFlowMessage &&
      !forceDisplay
    ) {
      startMessage();
    }
  }, [flowMessage, forceDisplay]);

  const startMessage = () => {
    const autoHideMessage = messageDuration !== null;
    setState((s) => ({
      ...s,
      forceDisplay: true,
      currentFlowMessage: flowMessage?.id,
    }));
    if (autoHideMessage) {
      setTimeout(() => {
        startToHideMessage();
      }, hidingMessageStartTime);
    }
  };

  const startToHideMessage = () => {
    dispatch({
      type: "SET_FLOW_MESSAGE",
      payload: { id: undefined },
    });
    setState((s) => ({ ...s, hideAnimation: true }));
    setTimeout(() => {
      startFadingWindow();
    }, fadeStartTimeFromHidingStartTime);
    setTimeout(() => {
      resetState();
    }, messageDuration - hidingMessageStartTime);
  };

  const startFadingWindow = () => {
    setState((s) => ({ ...s, fading: true }));
  };

  const resetState = () => {
    setState((s) => ({
      ...s,
      currentFlowMessage: undefined,
      forceDisplay: false,
      fading: false,
      hideAnimation: false,
    }));
  };
  const fadeInClassName = flowMessage?.fadeIn === true ? "fade-in-anim" : "";
  const hidingUnderneathShadowClassConditions = isScreenXs
    ? "hiding-underneath-shadow"
    : "";
  const fadingClassConditions = fading ? "disappear-anim" : fadeInClassName;
  const flowMessagesClassName = `${fadingClassConditions} ${hidingUnderneathShadowClassConditions}`;

  return (
    <>
      {forceDisplay && (
        <Box
          zIndex={"modal"}
          className={flowMessagesClassName}
          width={"100%"}
          minHeight={"100%"}
          left={0}
          top={0}
          position={"absolute"}
          display={"flex"}
          style={isScreenXs ? { boxShadow: "0 0 0 300px #fff" } : {}}
        >
          <Paper elevation={0} className={"w-100 text-center"}>
            <ResponsiveLayout>
              {FLOW_MESSAGES[flowMessage?.id || currentFlowMessage]?.component(
                hideAnimation,
                startToHideMessage
              )}
            </ResponsiveLayout>
          </Paper>
        </Box>
      )}
    </>
  );
}
